export default class CAIA0050RequestModel {}
